import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageDocuments } from "@components/modules/brands/documents/PageDocuments";
import { NavigationBrand } from "@components/widgets/AppSubNav/NavigationBrand";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Brand documents`}
    navigation={<NavigationBrand id={id} variant="panel" />}
  >
    <PageDocuments />
  </MainLayout>
);
const RouteComponent = withId(Page);

export const Route = createFileRoute("/brands/documents")({
  component: RouteComponent,
});
